import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Tag/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	iconSvgId: string | null;
	categoryId?: string;
	display: boolean;
	nameTranslations: {
		[key: string]: string;
	};
}
